import { useI18n } from "@/lib/i18n";
import { Reveal, SectionHead } from "./Reveal";

export const Marquee = () => {
  const { t } = useI18n();
  const text = t("marquee");
  return (
    <div className="py-8 border-y border-[var(--elt-line)] overflow-hidden bg-[#0D0E11]" data-testid="editorial-marquee">
      <div className="marquee-track">
        {[0, 1].map((i) => (
          <span key={i} className="font-serif-elt italic font-light text-xl md:text-2xl text-[var(--elt-gold-light)]/60 tracking-wide pr-4">
            {text} {text}
          </span>
        ))}
      </div>
    </div>
  );
};

export const Manifesto = () => {
  const { t } = useI18n();
  const chapters = t("manifesto.chapters");
  return (
    <section id="experience" className="max-w-[1440px] mx-auto px-6 lg:px-10 py-28 lg:py-40">
      <div className="grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <SectionHead eyebrow={t("manifesto.eyebrow")} title={t("manifesto.title")} />
          <Reveal delay={0.15}>
            <p className="mt-8 text-sm md:text-base font-light leading-relaxed text-[var(--elt-muted)] max-w-md">{t("manifesto.body")}</p>
            <p className="mt-10 font-serif-elt text-xl md:text-2xl font-light text-[var(--elt-ivory)]">{t("manifesto.statement1")}</p>
            <p className="font-serif-elt text-xl md:text-2xl italic text-[var(--elt-gold-light)]">{t("manifesto.statement2")}</p>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div className="group flex gap-8 py-8 border-b border-white/8 hover:border-[var(--elt-line)] transition-colors duration-500" data-testid={`manifesto-chapter-${i}`}>
                <span className="font-serif-elt text-3xl md:text-4xl font-light text-[var(--elt-gold)]/40 group-hover:text-[var(--elt-gold)] transition-colors duration-500 w-14 shrink-0">{c.n}</span>
                <div>
                  <h3 className="text-sm tracking-[0.28em] uppercase text-[var(--elt-ivory)] mb-2">{c.title}</h3>
                  <p className="text-sm font-light text-[var(--elt-muted)] leading-relaxed max-w-md">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
